export const AppRoutes = {
    DeleteAccount: () : string => '/',
    PrivacyPolicy: () : string => '/privacy-policy',
    TermsAndConditions: () : string => '/terms-and-conditions',
} as const;
